// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** 
* Change Font or do the normalization here
*/
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: black;
}

p {
  cursor: default;
}

::-webkit-scrollbar {
  width: 0;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
.__topBanner::-webkit-scrollbar {
  width: 3px !important;
  /* Remove scrollbar space */
  height: 5px;
  background: #262626 !important;
  /* Optional: just make scrollbar invisible */
  cursor: pointer !important;
}

/* Optional: show position indicator in red */
.__topBanner::-webkit-scrollbar-thumb {
  cursor: pointer !important;
  background: #999999 !important;
  /* Optional: just make scrollbar invisible */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

#root {
  height: inherit;
}

.fs-14 {
  font-size: 14px;
}

.__loader {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4392156863);
  z-index: 1000000000;
}

.__loader_inside {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4392156863);
  z-index: 1000000000;
}

.notifications-component {
  top: 0 !important;
  right: 0 !important;
}

.notification__item--danger {
  background-color: #e3293e;
}

.notification__item--success {
  background-color: #05c95f;
}

.notification__item--warning {
  background-color: #FFEE20;
}

.date-click::-webkit-calendar-picker-indicator {
  right: -10px !important;
  position: absolute !important;
  width: 100% !important;
  height: 40px !important;
  opacity: 0 !important;
}

input:focus {
  outline: none !important;
}

.mymusic_table {
  width: 100%;
  border-spacing: 0px;
}
.mymusic_table thead tr th:first-child {
  text-align: left;
  padding: 15px 18px;
}
.mymusic_table thead tr th:last-child {
  text-align: right;
  padding: 15px 18px;
}
.mymusic_table thead tr th {
  color: #ffffff;
  padding: 15px 18px;
  font-size: 14px;
}
.mymusic_table tbody {
  width: inherit;
}
.mymusic_table tbody tr {
  width: inherit;
  position: relative;
  height: 67.5px;
}
.mymusic_table tbody tr:hover {
  background: #000000;
}
.mymusic_table tbody tr td:first-child {
  padding-left: 18px;
}
.mymusic_table tbody tr td:last-child {
  padding-right: 18px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.MuiSlider-valueLabel {
  background-color: #262626 !important;
  display: none !important;
}

.__siki_chip:hover {
  background-color: #000000 !important;
  color: #FFFFFF;
  border-color: #FFFFFF;
}

#maps_control_1_MapAreaBorder {
  fill: #090909 !important;
}

.p-tooltip .p-tooltip-text {
  color: #666699 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACE,SAAA;EAEA,uFAAA;EACA,mCAAA;EACA,kCAAA;EACE,uBAAA;AADJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,4CAAA;AADF;;AAIA,6CAAA;AAGA;EACE,qBAAA;EACA,2BAAA;EACA,WAAA;EACA,8BAAA;EACA,4CAAA;EACA,0BAAA;AAHF;;AAMA,6CAAA;AACA;EACE,0BAAA;EACA,8BAAA;EACA,4CAAA;AAHF;;AAMA;EACE,+EAAA;AAHF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,6CAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,6CAAA;EACA,mBAAA;AALF;;AAQA;EACE,iBAAA;EACA,mBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EAEA,qBAAA;AANF;;AASA;EACE,wBAAA;AANF;;AASA;EACE,WAAA;EACA,mBAAA;AANF;AAUM;EACE,gBAAA;EACA,kBAAA;AARR;AAWM;EACE,iBAAA;EACA,kBAAA;AATR;AAYM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAVR;AAeE;EACE,cAAA;AAbJ;AAeI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAbN;AAeM;EACE,mBAAA;AAbR;AAgBM;EACE,kBAAA;AAdR;AAiBM;EAEE,mBAAA;AAfR;;AAqBA;;EAEE,wBAAA;EACA,SAAA;AAlBF;;AAqBA,YAAA;AACA;EACE,0BAAA;AAlBF;;AAqBA;EACE,oCAAA;EAIA,wBAAA;AAtBF;;AA2BE;EACE,oCAAA;EACA,cAAA;EACA,qBAAA;AApBJ;;AAwBA;EACM,wBAAA;AArBN;;AAwBA;EACE,yBAAA;AArBF","sourcesContent":["/** \n* Change Font or do the normalization here\n*/\n\nbody {\n  margin: 0;\n\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n    background-color: black;\n}\n\np {\n  cursor: default;\n}\n\n::-webkit-scrollbar {\n  width: 0;\n  /* Remove scrollbar space */\n  background: transparent;\n  /* Optional: just make scrollbar invisible */\n}\n\n/* Optional: show position indicator in red */\n::-webkit-scrollbar-thumb {}\n\n.__topBanner::-webkit-scrollbar {\n  width: 3px !important;\n  /* Remove scrollbar space */\n  height: 5px;\n  background: #262626 !important;\n  /* Optional: just make scrollbar invisible */\n  cursor: pointer !important;\n}\n\n/* Optional: show position indicator in red */\n.__topBanner::-webkit-scrollbar-thumb {\n  cursor: pointer !important;\n  background: #999999 !important;\n  /* Optional: just make scrollbar invisible */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n#root {\n  height: inherit;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.__loader {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: #00000070;\n  z-index: 1000000000;\n}\n\n.__loader_inside {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: #00000070;\n  z-index: 1000000000;\n}\n\n.notifications-component {\n  top: 0 !important;\n  right: 0 !important;\n}\n\n.notification__item--danger {\n  background-color: #e3293e;\n}\n\n.notification__item--success {\n  background-color: #05c95f;\n}\n\n.notification__item--warning {\n  background-color: #FFEE20;\n}\n\n.date-click::-webkit-calendar-picker-indicator {\n  right: -10px !important;\n  position: absolute !important;\n  width: 100% !important;\n  height: 40px !important;\n\n  opacity: 0 !important;\n}\n\ninput:focus {\n  outline: none !important;\n}\n\n.mymusic_table {\n  width: 100%;\n  border-spacing: 0px;\n\n  thead {\n    tr {\n      th:first-child {\n        text-align: left;\n        padding: 15px 18px;\n      }\n\n      th:last-child {\n        text-align: right;\n        padding: 15px 18px;\n      }\n\n      th {\n        color: #ffffff;\n        padding: 15px 18px;\n        font-size: 14px;\n      }\n    }\n  }\n\n  tbody {\n    width: inherit;\n\n    tr {\n      width: inherit;\n      position: relative;\n      height: 67.5px;\n\n      &:hover {\n        background: #000000;\n      }\n\n      td:first-child {\n        padding-left: 18px;\n      }\n\n      td:last-child {\n        padding-right: 18px;\n        padding-right: 18px;\n      }\n    }\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.MuiSlider-valueLabel {\n  background-color: #262626 !important;\n}\n\n.MuiSlider-valueLabel {\n  display: none !important;\n}\n\n\n.__siki_chip {\n  &:hover {\n    background-color: #000000 !important;\n    color: #FFFFFF;\n    border-color: #FFFFFF\n  }\n}\n\n#maps_control_1_MapAreaBorder{\n      fill: #090909 !important;\n}\n\n.p-tooltip .p-tooltip-text {\n  color: #666699 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
